import _ from 'lodash';
//reducers
import { useAppSelector } from 'hooks/redux.hooks';
import { getCountries, getCurrencies } from 'state/reducers/global.reducers';
//theme
import { HeaderPage1 } from 'theme/elements/Headers';
//components
import { Flag } from 'theme/elements/Icons';
//MUI
import { Box, Stack } from '@mui/material';
//constants
import { Beneficiary, beneficiaryType } from 'constants/beneficiary.constants';

export default function BeneficiaryNameWithFlag(props: { beneficiary: Partial<Beneficiary> }) {
	const { beneficiary } = props;
	const countries = _.keyBy(useAppSelector(getCountries), 'id');
	const currencies = _.keyBy(useAppSelector(getCurrencies), 'id');
	const getCountryCode = () => {
		if (_.get(countries, beneficiary.countryId || '')) {
			return String(_.get(countries, beneficiary.countryId || '').alpha2Code);
		}
		return '';
	};
	const getCompanyName = () => {
		return _.isEqual(beneficiary.type, beneficiaryType.COMPANY)
			? beneficiary.companyName
			: beneficiary.firstName + ' ' + beneficiary.lastName;
	};
	return (
		<Stack direction="row" spacing={1} flexGrow={2}>
			<Box marginTop={'0px'}>
				<Flag title={_.lowerCase(getCountryCode())} />
			</Box>
			<HeaderPage1
				title={beneficiary.nickname || ''}
				text={
					_.has(currencies, beneficiary?.currencyId || '')
						? _.get(currencies, beneficiary?.currencyId || '').code
						: ''
				}
				subtext={getCompanyName()}
			/>
		</Stack>
	);
}
